import { Component, inject } from '@angular/core';
import { UserStateService } from '../../services/user-state.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [MatButtonModule]
})
export class HomeComponent {
  readonly userState = inject(UserStateService);

  signIn(): void {
    this.userState.signIn();
  }
}
